import { CalendarIcon, ClockIcon, LockClosedIcon } from "@heroicons/react/20/solid";
import { addDays, format, parse } from "date-fns";
import React from "react";

const DateInputFormat = React.forwardRef(({ onClick, disabled, value, onChange, onFocus, onKeyDown, className, name, ...props }, ref) => {
	return (
		<div className="input-group input-date date">
			<input
				ref={ref}
				value={value}
				onChange={onChange}
				onFocus={onFocus}
				onKeyDown={onKeyDown}
				className={className}
				name={name}
				disabled={disabled}
				style={{
					border: `solid 1px ${disabled ? "#eceff1" : "#bbbcbc"}`,
					width: "100%",
					background: disabled ? "#eceff1" : "#fff",
					padding: "4px",
					height: "38px",
					cursor: disabled ? "not-allowed" : "auto",
				}}
				{...props}
			/>
			<span
				className="input-group-addon"
				onClick={onClick}
				style={{ cursor: disabled ? "not-allowed" : "auto" }}
			>
				{!disabled ? (
					<CalendarIcon style={{ height: "2rem" }} />
				) : (
					<LockClosedIcon style={{ height: "2rem" }} />
				)}
			</span>
		</div>
	);
});

const DayMonthHeader = React.forwardRef(
	({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }, ref) => {
		const month = format(date, "MMMM");

		return (
			<div ref={ref}>
				{!prevMonthButtonDisabled && (
					<button
						type="button"
						className="react-datepicker__navigation react-datepicker__navigation--previous"
						aria-label="Previous Month"
						onClick={decreaseMonth}
					>
						Previous Month
					</button>
				)}
				<div className="react-datepicker__current-month">{month}</div>
				{!nextMonthButtonDisabled && (
					<button
						type="button"
						className="react-datepicker__navigation react-datepicker__navigation--next"
						aria-label="Next Month"
						onClick={increaseMonth}
					>
						Next Month
					</button>
				)}
			</div>
		);
	},
);

const TimeInputFormat = React.forwardRef(
	({ value, onChange, onClick, onFocus, onKeyDown, name, disabled, className, ...props }, ref) => {
		return (
			<div className="input-group input-date date">
				<input
					ref={ref}
					value={value}
					onChange={onChange}
					onFocus={onFocus}
					onKeyDown={onKeyDown}
					className={className}
					name={name}
					disabled={disabled}
					style={{
						border: `solid 1px ${disabled ? "#eceff1" : "#bbbcbc"}`,
						width: "100%",
						background: disabled ? "#eceff1" : "#fff",
						padding: "4px",
						height: "38px",
						cursor: disabled ? "not-allowed" : "auto",
					}}
					{...props}
				/>
				<span
					className="input-group-addon"
					onClick={onClick}
					style={{ cursor: disabled ? "not-allowed" : "auto" }}
				>
					{!disabled ? (
						<ClockIcon style={{ height: "2rem" }} />
					) : (
						<LockClosedIcon style={{ height: "2rem" }} />
					)}
				</span>
			</div>
		);
	},
);

const handleRawDate = (value, updateDate) => {
	if (value?.length == 10 && value?.split("/")?.length == 3) {
		value = parse(value, "dd/MM/yyyy", new Date());
	} else if (value?.length == 11) {
		value = parse(value, "dd MMM yyyy", new Date());
	} else if (value?.toLowerCase() == "tomorrow") {
		value = addDays(new Date(), 1);
	} else if (value?.toLowerCase() == "yesterday") {
		value = addDays(new Date(), -1);
	} else if (value?.toLowerCase() == "today") {
		value = new Date();
	}

	if (typeof value == "object") {
		updateDate(value);
	}
	return value;
};

export { DateInputFormat, DayMonthHeader, TimeInputFormat, handleRawDate };
